/**
 * @Relay no-runtime
 */
import graphql from 'graphql-tag';

export const PermissionCheckAddCommentQuery = graphql`
	query PermissionCheckAddCommentQuery($contentId: ID!) {
		content(id: $contentId, status: ["draft", "current"]) {
			nodes {
				id
				type
				operations {
					operation
					targetType
				}
			}
		}
	}
`;
